<template>
  <v-container fluid fill-height>
      <v-layout align-space-around justify-start fill-height column>
          <v-flex sm12>
              <v-toolbar
                color="#eee"
                class="elevation-0 secondary--text mb-4"
                style="background: transparent"
              >
                  <v-toolbar-title>Meus Clientes</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" v-on="on" @click="filtrar=!filtrar">
                        <v-icon>{{ filtrar ? 'filter_list_off' : 'filter_list'}}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ filtrar ? 'Recolher Filtro' : 'Filtrar' }}</span>
                  </v-tooltip>
                  <cad-cliente
                    @cadastroRealizado="carregarClientes"
                    :btn="true"
                  ></cad-cliente>
              </v-toolbar>
              <v-slide-x-transition>
                <v-card v-show="filtrar" class="ml-4 mr-4 mb-4">
                  <v-card-text>
                    <v-layout wrap justify-space-between>
                      <v-flex xs10 md11>
                        <v-layout wrap justify-space-around>
                          <v-flex xs11 sm5 md3 lg2 xl2>
                            <label>Identificador:</label>
                            <v-text-field
                              class="ma-0"
                              solo
                              v-model="id_pessoa"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm5 md4 lg3 xl2>
                            <label>Nome:</label>
                            <v-text-field
                              v-model="nome"
                              solo
                              class="ma-0"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm4 md4 lg3 xl2>
                            <v-checkbox
                              v-model="assinante"
                              label="Apenas Assinantes"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs11 sm4 md4 lg3 xl2>
                            <v-checkbox
                              v-model="apenasPlus"
                              label="Apenas Cliente Plus"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs11 sm4 md4 lg3 xl2 v-if="posto">
                            <v-checkbox
                              v-model="apenasRede"
                              label="Mostrar Clientes da Rede"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex
                            xs11
                            sm11
                            md4
                            lg4
                            xl2
                          >
                            <label>Mostrar cliente que não compram a:</label>
                            <v-text-field
                              class="ma-0"
                              suffix="dias"
                              v-model="dias"
                              solo
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs2 md1 align-self-center>
                        <v-btn fab color="primary" @click="carregarClientes(true)">
                          <v-icon>search</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-slide-x-transition>
          </v-flex>
          <v-data-table
            hide-actions
            :hide-headers="!clientes.length"
            :items="clientes"
            :pagination.sync="pagination"
            :headers="clienteHeader"
            :total-items="totalItems"
            class="elevation-1"
            :loading="loading"
          >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
              Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
              <td style="width: 10px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-avatar
                      color="primary"
                      size="30"
                      v-on="on"
                    >
                      <v-icon dark>person</v-icon>
                    </v-avatar>
                  </template>
                  <span>{{ props.item.rede ? 'Inscrição na Rede de Posto' : 'Inscrição no Posto' }}</span>
                </v-tooltip>
              </td>
              <td class="text-xs-start">
                <template v-if="props.item && props.item.pessoa.id_pessoa">
                  {{ props.item.pessoa.id_pessoa }}
                </template>
              </td>
              <td class="text-xs-start">
                <template v-if="props.item && props.item.pessoa.nome_completo">
                  {{ props.item.pessoa.nome_completo }}
                </template>
              </td>
              <td class="text-xs-start">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" :color="isSubscriber(props.item.inscricao_posto) ? 'success' : 'error'">
                      {{ isSubscriber(props.item.inscricao_posto) ? 'check_circle' : 'cancel' }}
                    </v-icon>
                  </template>
                  <span>{{ isSubscriber(props.item.inscricao_posto) ? 'Participa do Programa de Assinatura' : 'Não participa do Programa de Assinatura' }}</span>
                </v-tooltip>
              </td>
             <td class="text-xs-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn flat icon color="primary" v-on="on">
                    <v-icon>{{isPlus(props.item.inscricao_posto) ? 'star' : 'star_outline'}}</v-icon>
                  </v-btn>
                </template>
                <span>{{ isPlus(props.item.inscricao_posto) ? 'Cliente Plus' : 'Não é Cliente Plus' }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    flat
                    icon
                    color='primary'
                    @click="clienteSelecionado = props.item, dialogEnviarEmail= true"
                    v-on="on"
                  >
                    <v-icon class="mr-1">mail</v-icon>
                  </v-btn>
                </template>
                <span>Enviar e-mail para cliente</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    flat
                    icon
                    color='primary'
                    @click="clienteSelecionado = props.item, dialogNotificacao = true"
                    v-on="on"
                  >
                    <v-icon class="mr-1">chat_bubble</v-icon>
                  </v-btn>
                </template>
                <span>Enviar notificação para cliente</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn flat icon color="primary" @click="clienteSelecionado = props.item, dialogVisualizar = true" v-on="on">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </template>
                <span>Visualizar mais Detalhes</span>
              </v-tooltip>
            </td>
          </template>
          </v-data-table>
          <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
          </div>
      </v-layout>
  </v-container>
</template>

<script>
import CadCliente from '@/components/dialogs/CadCliente'

export default {
  components: {
    CadCliente
  },
  data () {
    return {
      filtrar: false,
      nome: undefined,
      id_pessoa: undefined,
      dias: undefined,
      assinante: false,
      apenasPlus: false,
      apenasRede: false,
      dialogNotificacao: false,
      dialogEmail: false,
      dialogVisualizar: false,
      dialogEnviarEmail: false,
      clienteSelecionado: undefined,
      clienteHeader: [
        {
          align: 'left',
          sortable: false
        },
        {
          text: 'Identificador',
          align: 'left',
          sortable: false,
          value: 'pessoa.id_pessoa'
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        {
          text: 'Assinante',
          align: 'left',
          sortable: false
        },
        {
          text: 'Plus',
          align: 'center',
          sortable: false
        },
        {
          align: 'left',
          sortable: false
        }
      ],
      clientes: [],
      totalItems: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      }
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      const pages = Math.ceil(this.totalItems / this.pagination.rowsPerPage)
      return pages
    },
    ready () {
      return !!this.posto || !!this.empresa
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (val && this.ready) {
          this.carregarClientes(false)
        }
      },
      deep: true
    },
    frentista (val) {
      if (val) this.carregarClientes(false)
    }
  },
  mounted () {
    if (this.ready) {
      if (this.ready && this.pagination && this.pagination.page) {
        this.carregarClientes(false)
      }
    }
  },
  methods: {
    carregarClientes (isBtn) {
      function subtrairDias (dias) {
        const hoje = new Date()
        hoje.setDate(hoje.getDate() - dias)
        return hoje
      }
      const data = {
        // posto: this.posto ? this.posto.cnpj : null,
        // empresa: this.empresa ? this.empresa.cnpj : null,
        ordering: 'pessoa__nome'
      }
      this.pagination.page = isBtn ? 1 : this.pagination.page
      data.page = this.pagination.page
      if (this.id_pessoa) data.pessoa = this.id_pessoa
      if (this.assinante) {
        data.inscricao__assinatura__isnull = !this.assinante
        data.is_assinate = this.assinante
      }
      if (this.apenasPlus) data.inscricao__cliente_plus = this.apenasPlus
      if (this.apenasRede) data.apenasRede = this.apenasRede
      if (this.nome) data.pessoa__nome__icontains = this.nome
      if (this.dias) {
        data.ultima_data_compra = subtrairDias(this.dias).toISOString().split('T')[0]
        data.ordering = 'ultima_compra'
      }
      this.$store.dispatch('pegarClientes', data).then(value => {
        this.clientes = value.results
        this.totalItems = value.count
      })
    },
    isSubscriber (listaInscricoes) {
      if (!listaInscricoes || listaInscricoes.length === 0) return false
      const lista = listaInscricoes.filter((obj) => {
        return !!obj.assinatura
      })
      return lista.length > 0
    },
    isPlus (listaInscricoes) {
      if (!listaInscricoes || listaInscricoes.length === 0) return false
      const lista = listaInscricoes.filter((obj) => {
        return obj.cliente_plus
      })
      return lista.length > 0
    }
  }
}
</script>
